import { render, staticRenderFns } from "./GrownFishModal.vue?vue&type=template&id=05d4448c&"
import script from "./GrownFishModal.vue?vue&type=script&lang=js&"
export * from "./GrownFishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports